import React from 'react';
import { Button } from './button';
import { Input } from './input';
import { Minus, Plus } from 'lucide-react';

export function NumberInput({ 
  value, 
  onChange, 
  min = 0, 
  max = 100, 
  step = 1,
  className = '',
  inputClassName = '',
  'data-testid': testId,
  ...props 
}) {
  const handleIncrement = () => {
    const newValue = Math.min(max, (value || 0) + step);
    onChange(newValue);
  };

  const handleDecrement = () => {
    const newValue = Math.max(min, (value || 0) - step);
    onChange(newValue);
  };

  const handleInputChange = (e) => {
    const newValue = parseInt(e.target.value) || min;
    onChange(Math.min(max, Math.max(min, newValue)));
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={handleDecrement}
        disabled={value <= min}
        className="h-12 w-12 shrink-0 rounded-lg border-slate-300 hover:bg-slate-100 hover:border-slate-400 disabled:opacity-50"
        data-testid={testId ? `${testId}-decrement` : undefined}
      >
        <Minus className="h-4 w-4" />
      </Button>
      <Input
        type="number"
        value={value}
        onChange={handleInputChange}
        min={min}
        max={max}
        className={`h-12 text-center font-medium ${inputClassName}`}
        data-testid={testId}
        {...props}
      />
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={handleIncrement}
        disabled={value >= max}
        className="h-12 w-12 shrink-0 rounded-lg border-slate-300 hover:bg-slate-100 hover:border-slate-400 disabled:opacity-50"
        data-testid={testId ? `${testId}-increment` : undefined}
      >
        <Plus className="h-4 w-4" />
      </Button>
    </div>
  );
}
